import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {CustomValidators} from '../../validators';

@Directive({
  selector:
    // tslint:disable-next-line:max-line-length
    ':not([type=checkbox])[emailFormat][formControlName],:not([type=checkbox])[emailFormat][formControl],:not([type=checkbox])[emailFormat][ngModel]',
  providers: [{provide: NG_VALIDATORS, useExisting: EmailFormatDirective, multi: true}],
})
export class EmailFormatDirective implements Validator {
  private _emailFormat = false;
  private _onChange?: () => void;

  /**
   * @description
   * Tracks changes to the chooseRequired attribute bound to this directive.
   */
  @Input()
  get emailFormat(): boolean | string {
    return this._emailFormat;
  }

  set emailFormat(value: boolean | string) {
    this._emailFormat = value != null && value !== false && `${value}` !== 'false';
    if (this._onChange) {
      this._onChange();
    }
  }

  /**
   * Method that validates whether the control is empty.
   * Returns the validation result if enabled, otherwise null.
   * @nodoc
   */
  validate(control: AbstractControl): ValidationErrors | null {
    return this.emailFormat ? CustomValidators.emailFormat(control) : null;
  }

  /**
   * Registers a callback function to call when the validator inputs change.
   * @nodoc
   */
  registerOnValidatorChange(fn: () => void): void {
    this._onChange = fn;
  }
}
